import { createContext } from "react";
import type { SDK } from "vim-os-js-browser/api/vim-os-sdk-api";


export const VimOSContext = createContext<SDK | undefined>(undefined);
